import {
	sBanner,
	sIsValidPostcode,
	sInputKeyValidationHelper,
	sPostToEngagementTools,
} from '../../shared.min.js';

const airportJourneyPlanner = (function () {
	let apiKey = '';
	let aiAPI = '';
	let airports;

	const widget = document.getElementById('cnfsd-ajp-widget'),
		resultText = document.getElementById('ajp-cms'),
		bannerStep1Text = resultText.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = resultText.getAttribute('data-banner-step-2-text'),
		bannerStep3Text = resultText.getAttribute('data-banner-step-3-text'),
		errorTransportRadio = resultText.getAttribute('data-error-transport-radio'),
		errorAirportDropdown = resultText.getAttribute('data-error-airport-dropdown'),
		errorDateSelect = resultText.getAttribute('data-error-date-select'),
		errorDateReturnAfter = resultText.getAttribute('data-error-return-after'),
		errorTimeSelect = resultText.getAttribute('data-error-time-select'),
		screen1 = widget ? widget.querySelector('#screen-1') : null,
		errorScreen = widget ? widget.querySelector('#errorScreen') : null,
		postcode = widget ? widget.querySelector('#ajpPostcode') : null,
		radioAP = widget ? widget.querySelector('#airport-parking') : null,
		radioPT = widget ? widget.querySelector('#public-transport') : null,
		radioAS = widget ? widget.querySelector('#all-services') : null,
		screen2 = widget ? widget.querySelector('#screen-2') : null,
		submitBtn = widget ? widget.querySelector('#ajp-btn-submit') : null,
		routeStart = widget ? widget.querySelectorAll('.routeStart') : null,
		routeFinish = widget ? widget.querySelectorAll('.routeFinish') : null,
		dropdownInput = widget ? widget.querySelector('#dropdownInput') : null,
		departureInput = widget ? widget.querySelector('#ajp-departure') : null,
		returnInput = widget ? widget.querySelector('#ajp-return') : null,
		timeInput = widget ? widget.querySelector('#airport_time_input') : null,
		results = widget ? widget.querySelector('#results') : null,
		resetBtns = widget ? widget.querySelectorAll('.reset-btn') : [],
		editBtns = widget ? widget.querySelectorAll('.edit-previous') : [],
		//Best on price section
		resultTitleBoP = widget ? widget.querySelector('#resultTitleBoP') : null,
		priceOneWayBoP = widget ? widget.querySelector('#priceOneWay') : null,
		priceReturnBoP = widget ? widget.querySelector('#priceReturn') : null,
		travelTimeBoP = widget ? widget.querySelector('#priceTravelTime') : null,
		priceProBoP = widget ? widget.querySelector('#pricePros') : null,
		priceConBoP = widget ? widget.querySelector('#priceCons') : null,
		//Best for convenience section
		resultTitleBfC = widget ? widget.querySelector('#resultTitleBfC') : null,
		priceOneWayBfC = widget ? widget.querySelector('#convOneWayValue') : null,
		priceReturnBfC = widget ? widget.querySelector('#convReturnValue') : null,
		travelTimeBfC = widget ? widget.querySelector('#convTravelTime') : null,
		proBfC = widget ? widget.querySelector('#convPros') : null,
		conBfC = widget ? widget.querySelector('#convCons') : null,
		// Update Best for time-saving section
		resultTitleBfT = widget ? widget.querySelector('#resultTitleBfT') : null,
		priceonewayBfT = widget ? widget.querySelector('#timeOneWayValue') : null,
		priceReturnBfT = widget ? widget.querySelector('#timeReturnValue') : null,
		travelTimeBfT = widget ? widget.querySelector('#timeTravelTime') : null,
		proBfT = widget ? widget.querySelector('#timePros') : null,
		conBfT = widget ? widget.querySelector('#timeCons') : null,
		screenOneErrorContainers = document.querySelectorAll(
			'.airport-journey-planner__screen-1 .field-validation-error'
		),
		screenTwoErrorContainers = widget ? widget.querySelectorAll('.airport-journey-planner__screen-2 .field-validation-error') : null,
		radioInputs = widget ? widget.querySelectorAll("input[name='select-radio'") : null,
		input = widget ? widget.querySelector('#dropdownInput') : null,
		dropdownList = widget ? widget.querySelector('#dropdownList') : null,
		screenOneForm = widget ? widget.querySelector('#airportJourney') : null,
		screenTwoForm = widget ? widget.querySelector('#ajp-your-trip') : null,
		restartButton = widget ? widget.querySelector('#restart-btn') : null;

	const scrollToTopOfCalc = () => {
		const target = document.querySelector('#cnfsd-ajp-widget');
		const offset = 110;
		const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

		window.scrollTo({
			top: topPos,
			behavior: 'smooth', // or 'auto' if you don't want smooth scroll
		});
	};

	//Buttons
	screenOneForm.addEventListener('submit', e => {
		e.preventDefault();
		const postcodeErrorMessages = {
			notValid: resultText.getAttribute('data-error-postcode'),
		};
		const postcodeValueCheck = document.querySelector('#ajpPostcode').value.trim(),
			validationResult = sIsValidPostcode(postcodeValueCheck, postcodeErrorMessages),
			fieldset = document.querySelector('#airportJourney fieldset'),
			errorContainers = fieldset.querySelectorAll('.field-validation-error'),
			postcodeErrorContainer = errorContainers[0],
			radioErrorContainer = errorContainers[1],
			pcErrorElement = postcodeErrorContainer.querySelector('.error-message'),
			radioErrorElement = radioErrorContainer.querySelector('.error-message');

		let hasErrors = false;
		pcErrorElement.textContent = '';
		radioErrorElement.textContent = '';
		postcodeErrorContainer.style.display = 'none';
		radioErrorContainer.style.display = 'none';

		// Validate postcode
		if (!validationResult.isValid) {
			pcErrorElement.textContent = postcodeErrorMessages.notValid;
			postcodeErrorContainer.style.display = 'block';
			hasErrors = true;
		}

		// Validate radio buttons
		if (!radioAP.checked && !radioPT.checked && !radioAS.checked) {
			radioErrorElement.textContent = errorTransportRadio;
			radioErrorContainer.style.display = 'block';
			hasErrors = true;
		}

		if (hasErrors) {
			e.preventDefault();
			scrollToTopOfCalc();
			return;
		}

		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text, bannerStep3Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			2
		);

		screen1.classList.add('display-none');
		screen2.classList.remove('display-none');
		scrollToTopOfCalc();
	});

	screenTwoForm.addEventListener('submit', async e => {
		e.preventDefault();
		//Validation
		const form = document.getElementById('ajp-your-trip'),
			errorContainers = form.querySelectorAll('.field-validation-error'),
			airportError = errorContainers[0].querySelector('.error-message'),
			dateError = errorContainers[1].querySelector('.error-message'),
			timeError = errorContainers[2].querySelector('.error-message');

		let hasError = false;

		// Validate each input...
		if (dropdownInput.value.trim() === '') {
			airportError.textContent = errorAirportDropdown;
			errorContainers[0].style.display = 'block';
			hasError = true;
		} else {
			airportError.textContent = '';
			errorContainers[0].style.display = 'none';
		}

		if (!departureInput.value || !returnInput.value) {
			dateError.textContent = errorDateSelect;
			errorContainers[1].style.display = 'block';
			hasError = true;
		} else if (new Date(departureInput.value) > new Date(returnInput.value)) {
			dateError.textContent = errorDateReturnAfter;
			errorContainers[1].style.display = 'block';
			hasError = true;
		} else {
			dateError.textContent = '';
			errorContainers[1].style.display = 'none';
		}

		if (!timeInput.value) {
			timeError.textContent = errorTimeSelect;
			errorContainers[2].style.display = 'block';
			hasError = true;
		} else {
			timeError.textContent = '';
			errorContainers[2].style.display = 'none';
		}

		if (hasError) {
			scrollToTopOfCalc();
			return;
		}

		submitBtn.classList.add('btn--loading');
		[priceOneWayBoP, priceReturnBoP, priceOneWayBfC, priceReturnBfC, priceonewayBfT, priceReturnBfT].forEach(el =>
			el.classList.remove('display-none')
		);
		screen1.classList.add('display-none');

		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text, bannerStep3Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			3
		);

		const postcodeValue = document.getElementById('ajpPostcode').value,
			airport = document.getElementById('dropdownInput').value,
			departureDate = document.getElementById('ajp-departure').value,
			returnDate = document.getElementById('ajp-return').value,
			// timeHour = document.getElementById("time-hrs").value,
			// timeMin = document.getElementById("time-min").value,
			transportOption = document.querySelector("input[name='select-radio']:checked").value,
			postcodeInput = postcode.value,
			shortPostcode = postcodeInput.trim().substring(0, 4);

		const [timeHour, timeMin] = timeInput.value.split(':');

		try {
			const res = await sPostToEngagementTools(
				{
					postcode: shortPostcode,
					transportOption,
					airport,
					departureDate,
					returnDate,
					timeToArriveHour: timeHour,
					timeToArriveMinute: timeMin,
				},
				apiKey,
				aiAPI
			);

			if (!res.ok) throw new Error(res.status);
			const responseData = await res.json();

			// Populate results page
			resultTitleBoP.textContent = responseData['Best on price']['Service Name'];
			priceOneWayBoP.textContent = responseData['Best on price'].Details['One way'];
			priceReturnBoP.textContent = responseData['Best on price'].Details['Return'];
			travelTimeBoP.textContent = responseData['Best on price'].Details['Time'];
			priceProBoP.textContent = responseData['Best on price'].Details['Pro'];
			priceConBoP.textContent = responseData['Best on price'].Details['Con'];

			resultTitleBfC.textContent = responseData['Best for convenience']['Service Name'];
			priceOneWayBfC.textContent = responseData['Best for convenience'].Details['One way'];
			priceReturnBfC.textContent = responseData['Best for convenience'].Details['Return'];
			travelTimeBfC.textContent = responseData['Best for convenience'].Details['Time'];
			proBfC.textContent = responseData['Best for convenience'].Details['Pro'];
			conBfC.textContent = responseData['Best for convenience'].Details['Con'];

			resultTitleBfT.textContent = responseData['Best for time-saving']['Service Name'];
			priceonewayBfT.textContent = responseData['Best for time-saving'].Details['One way'];
			priceReturnBfT.textContent = responseData['Best for time-saving'].Details['Return'];
			travelTimeBfT.textContent = responseData['Best for time-saving'].Details['Time'];
			proBfT.textContent = responseData['Best for time-saving'].Details['Pro'];
			conBfT.textContent = responseData['Best for time-saving'].Details['Con'];

			routeStart.forEach(el => (el.textContent = postcodeValue.toUpperCase()));
			routeFinish.forEach(el => (el.textContent = airport));

			function hidePricesIfParking(serviceName, oneWayEl, returnEl, sectionKey = null, costDaysSelector = null) {
				const nameLower = serviceName.toLowerCase();

				if (nameLower.includes('parking') || nameLower.includes('park') || nameLower.includes('driveway')) {
					// Try to find the costSection by walking up the DOM from either price element
					const costSection =
						oneWayEl?.closest('.result-section')?.querySelector('.costSection') ||
						returnEl?.closest('.result-section')?.querySelector('.costSection');

					if (costSection) {
						costSection.classList.add('display-none');
					}
					// Try to show "Service for X days"
					if (sectionKey && costDaysSelector) {
						const details = responseData?.[sectionKey]?.Details;

						if (!details) {
							return;
						}

						const entries = Object.entries(details);

						if (entries.length > 2) {
							const [label, value] = entries[2]; //service for x is the 3rd position in the result
							const costDaysEl = document.querySelector(costDaysSelector);
							const labelEl = costDaysEl?.querySelector('.serviceforx');
							const valueEl = costDaysEl?.querySelector('.costForDays');

							if (costDaysEl && labelEl && valueEl) {
								labelEl.textContent = label;
								valueEl.textContent = value;
								costDaysEl.classList.remove('display-none');
							}
						}
					}
				}
			}

			hidePricesIfParking(
				responseData['Best on price']['Service Name'],
				priceOneWayBoP,
				priceReturnBoP,
				'Best on price',
				'.costDaysBoP'
			);

			hidePricesIfParking(
				responseData['Best for convenience']['Service Name'],
				priceOneWayBfC,
				priceReturnBfC,
				'Best for convenience',
				'.costDaysBfC'
			);

			hidePricesIfParking(
				responseData['Best for time-saving']['Service Name'],
				priceonewayBfT,
				priceReturnBfT,
				'Best for time-saving',
				'.costDaysBfT'
			);

			//tooltip based on result data
			setToolTip(responseData['Best on price']['Service Name'], 'toolTipBoP', 'toolTipTextBoP');
			setToolTip(responseData['Best for convenience']['Service Name'], 'toolTipBfC', 'toolTipTextBfC');
			setToolTip(responseData['Best for time-saving']['Service Name'], 'toolTipBfT', 'toolTipTextBfT');

			function setToolTip(serviceName, tipContainerId, tipTextSpanId) {
				const tooltip = document.getElementById(tipContainerId);
				const tipText = document.getElementById(tipTextSpanId);
				tooltip.classList.add('display-none');
				const nameLower = serviceName.toLowerCase();
				const publicTransportKeyWords = ['public', 'bus', 'coach', 'train'];
				const parkingKeyWords = ['parking', 'park', 'drive', 'car'];
				const taxiKeyWords = ['taxi', 'cab'];
				const publicTransportMessage = resultText.getAttribute('data-public-transport-tooltip-message');
				const taxiMessage = resultText.getAttribute('data-taxi-tooltip-message');
				const parkingMsgStart = resultText.getAttribute('data-parking-tooltip-message-start'),
					parkingMsgFirstURL = resultText.getAttribute('data-parking-tooltip-message-firstURL'),
					parkingMsgFirstURLText = resultText.getAttribute('data-parking-tooltip-message-firstURLText'),
					parkingMsgTextBetween = resultText.getAttribute('data-parking-tooltip-message-between'),
					parkingMsgSecondURL = resultText.getAttribute('data-parking-tooltip-message-secondURL'),
					parkingMsgSecondURLText = resultText.getAttribute('data-parking-tooltip-message-secondURL-text'),
					parkingMessage = `${parkingMsgStart} <a href="${parkingMsgFirstURL}">${parkingMsgFirstURLText}</a> ${parkingMsgTextBetween} <a href="${parkingMsgSecondURL}">${parkingMsgSecondURLText}</a>`;
				let message = '';

				if (publicTransportKeyWords.some(keyword => nameLower.includes(keyword))) {
					message = publicTransportMessage;
				} else if (parkingKeyWords.some(keyword => nameLower.includes(keyword))) {
					message = parkingMessage;
				} else if (taxiKeyWords.some(keyword => nameLower.includes(keyword))) {
					message = taxiMessage;
				}

				if (message) {
					tipText.innerHTML = message;
					tooltip.classList.remove('display-none');
				}
			}

			submitBtn.classList.remove('btn--loading');
			screen2.classList.add('display-none');
			results.classList.remove('display-none');
		} catch (error) {
			// TODO: REFACTOR THIS TO SHOW ERROR MESSAGE / ERROR SCREEN
			// INSTEAD OF JUST LOGGING TO THE CONSOLE.
			console.error('Error:', error);
			submitBtn.classList.remove('btn--loading');
			screen2.classList.add('display-none');
			errorScreen.classList.remove('display-none');
		}

		scrollToTopOfCalc();
	});

	editBtns.forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();
			screen1.classList.add('display-none');
			results.classList.add('display-none');
			screen2.classList.remove('display-none');
			widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
			sBanner(
				widget,
				[bannerStep1Text, bannerStep2Text, bannerStep3Text],
				'.banner-current-text',
				'.banner-current-progress',
				'.banner__progress-bar__bar',
				2
			);
		});
	});

	restartButton.addEventListener('click', e => {
		e.preventDefault();
		screen1.classList.remove('display-none');
		results.classList.add('display-none');
		screen2.classList.add('display-none');
		errorScreen.classList.add('display-none');

		widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text, bannerStep3Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			0
		);
	});




	// HELPER METHOD:: Retrieves the API URL based upon the hostname of where the app is running
	function getSetApiDetails() {
		let localRoute = 'http://localhost:3000/foundry-ai/airport-journey-planner-bot';

		aiAPI = resultText
			? resultText.getAttribute('data-api-ai')
			: localRoute;
		apiKey = resultText ? resultText.getAttribute('data-api-key') : '';
		if (aiAPI.includes('local-')) {
			aiAPI = localRoute;
			apiKey = '';
		}
	}

	const setupKeyListener = () => {
		sInputKeyValidationHelper(postcode, 'alphaNumeric');
	};

	const handleValidationOnInputs = () => {
		const removeError = errorContainer => {
			errorContainer.removeAttribute('style');
			errorContainer.querySelector('.error-message').textContent = '';
		};

		postcode.addEventListener('keydown', () => {
			if (screenOneErrorContainers[0]) removeError(screenOneErrorContainers[0]);
		});
		radioInputs.forEach(radio => {
			radio.addEventListener('change', () => {
				if (screenOneErrorContainers[1]) removeError(screenOneErrorContainers[1]);
			});
		});
		input.addEventListener('keydown', () => {
			if (screenTwoErrorContainers[0]) removeError(screenTwoErrorContainers[0]);
		});
		[departureInput, returnInput].forEach(inputField => {
			inputField.addEventListener('change', () => {
				if (screenTwoErrorContainers[1]) removeError(screenTwoErrorContainers[1]);
			});
		});

		timeInput.addEventListener('change', () => {
			if (screenTwoErrorContainers[2]) removeError(screenTwoErrorContainers[2]);
		});
	};

	async function init() {
		getAirportData();

		setupKeyListener();

		handleValidationOnInputs();

		getSetApiDetails();

		const today = new Date().toISOString().split('T')[0];
		departureInput.setAttribute('min', today);
		returnInput.setAttribute('min', today);

		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text, bannerStep3Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);

		input.addEventListener('focus', () => {
			dropdownList.style.display = 'none';
		});

		input.addEventListener('input', handleInput);
		document.addEventListener('click', closeOnOutsideClick);

		function handleInput() {
			const query = this.value.trim().toLowerCase();

			if (!query) {
				dropdownList.style.display = 'none';
				return;
			}

			const filtered = airports.filter(
				a => a.name.toLowerCase().includes(query) || a.code.toLowerCase().includes(query)
			);

			if (filtered.length > 0) {
				renderList(filtered);
				dropdownList.style.display = 'block';
			} else {
				dropdownList.style.display = 'none';
			}
		}

		function closeOnOutsideClick(e) {
			if (!e.target.closest('.dropdown-container')) {
				dropdownList.style.display = 'none';
			}
		}

		function renderList(list) {
			dropdownList.innerHTML = '';
			list.forEach(airport => {
				const item = document.createElement('div');
				item.className = 'dropdown-item';
				item.textContent = `${airport.code} - ${airport.name}`;
				item.onclick = () => {
					input.value = `${airport.code} - ${airport.name}`;
					dropdownList.style.display = 'none';
				};
				dropdownList.appendChild(item);
			});
		}

		function restartCalc() {
			results.classList.add('display-none');
			screen2.classList.add('display-none');
			screen1.classList.remove('display-none');
			postcode.value = '';
			(dropdownInput.selectedIndex = 0),
				(departureInput.value = ''),
				(returnInput.value = ''),
				(timeInput.value = '');

			const radios = document.querySelectorAll("input[name='select-radio']");
			radios.forEach(radio => (radio.checked = false));

			document
				.getElementById('cnfsd-ajp-widget')
				.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

			sBanner(
				widget,
				[bannerStep1Text, bannerStep2Text, bannerStep3Text],
				'.banner-current-text',
				'.banner-current-progress',
				'.banner__progress-bar__bar',
				1
			);
		}

		//restart button
		if (resetBtns.length > 0) {
			resetBtns.forEach(resetBtn => {
				resetBtn.addEventListener('click', function (e) {
					e.preventDefault();
					restartCalc();
				});
			});
		}

		//Tab navigation
		const tabButtons = document.querySelectorAll('.mod-tabbable-content__nav-button'),
			tabContents = document.querySelectorAll('.mod-tab-content__content');

		tabButtons.forEach(button => {
			button.addEventListener('click', () => {
				const tabKey = button.getAttribute('data-tab');
				tabButtons.forEach(btn => btn.classList.remove('active'));
				button.classList.add('active');

				tabContents.forEach(section => {
					section.classList.add('display-none');
					section.classList.remove('initialised');
				});

				const targetSection = document.querySelector(`[data-tabbablecontent="${tabKey}"]`);
				if (targetSection) {
					targetSection.classList.remove('display-none');
					targetSection.classList.add('initialised');
				}
			});
		});
	}

	async function getAirportData() {
		//Fetch airport data
		const dataJsonPath = resultText.getAttribute('data-json-path');
		if (!dataJsonPath) {
			console.error('No data-json-path attribute found on resultText element.');
			return;
		}

		try {
			const response = await fetch(dataJsonPath);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			airports = await response.json();
		} catch (error) {
			console.error('Error fetching airport data:', error);
			airports = [];
		}
	}

	return { init };
})();

document.addEventListener('DOMContentLoaded', () => {
	airportJourneyPlanner.init();
});
